import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardSkogsvardTradslagPlanta } from "../../models/skogsvard/skogsvard-models";
import { SkogsvardTradslagPlantaBaseCommand } from "./SkogsvardTradslagPlantaBaseCommand";

export class UpdateSkogsvardTradslagPlantaCommand extends SkogsvardTradslagPlantaBaseCommand {
    readonly tradslagId: number;
    readonly planttyp: string;
    readonly plantskydd: string;
    readonly plantantal: number;
    readonly arealandel: number;
    readonly malPlantorHA: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateSkogsvardTradslagPlantaCommand";

    constructor(atgardGuid: string, planta: AtgardSkogsvardTradslagPlanta) {
        super(atgardGuid, planta.guid, UpdateSkogsvardTradslagPlantaCommand.$type, CommandType.Replace);
        this.tradslagId = planta.tradslagId;
        this.planttyp = planta.planttyp;
        this.plantantal = planta.plantantal;
        this.arealandel = planta.arealandel;
        this.malPlantorHA = planta.malPlantorHA;
        this.plantskydd = planta.plantskydd;
    }
}
